import type { MDXComponents } from "mdx/types";
import { Pre } from "./components/blog/Code";

export function useMDXComponents(components: MDXComponents): MDXComponents {
  return {
    h1: Header1,
    h2: Header2,
    h3: Header3,
    h4: Header4,
    h5: Header5,
    h6: Header6,
    ul: UnorderedList,
    ol: OrderedList,
    li: ListItem,
    blockquote: Blockquote,
    pre: Pre,
    code: Code,
    a: Anchor,
    table: Table,
    p: Paragraph,
    strong: Strong,
    ...components,
  };
}

export function Header1({ children, ...props }) {
  return (
    <h1
      {...props}
      children={children}
      className="mt-8 text-3xl font-bold text-center"
    />
  );
}

export function Header2({ children, ...props }) {
  return (
    <h2 {...props} className="mt-4 text-5xl">
      {children}
    </h2>
  );
}

export function Header3({ children, ...props }) {
  return <h3 {...props}>{children}</h3>;
}

export function Header4({ children, ...props }) {
  return <h4 {...props} children={children} className="mt-12 text-3xl" />;
}

export function Header5({ children, ...props }) {
  return <h5 {...props} children={children} className="mt-4 text-2xl" />;
}
export function Header6({ children, ...props }) {
  return <h6 {...props} children={children} className="mt-4 text-xl" />;
}
export function UnorderedList({ children, ...props }) {
  return <ul {...props} children={children} className="ml-4 list-disc" />;
}
export function OrderedList({ children, ...props }) {
  return <ol {...props} children={children} className="ml-4 list-decimal" />;
}
export function ListItem({ children, ...props }) {
  return <li {...props} children={children} className="mb-2 md:ml-4 lg:ml-8" />;
}
export function Blockquote({ children, ...props }) {
  return (
    <div className="">
      <blockquote
        {...props}
        children={children}
        className="px-6 py-2 m-4 overflow-x-auto font-serif text-xl bg-gray-100 rounded-lg card-shadow"
      />
    </div>
  );
}

export function Anchor({ children, ...props }) {
  return (
    <>
      <a
        {...props}
        target="_blank"
        rel="noopener"
        children={children}
        className="italic font-semibold underline __css_anchor"
      />
    </>
  );
}
export function Table({ children, ...props }) {
  return <table {...props} children={children} className="table-auto" />;
}

export function Paragraph({ children, textIndent = "2rem", ...props }) {
  return (
    <p
      {...props}
      style={{ textIndent: textIndent, color: "#222" }}
      children={children}
      className="my-4 whitespace-pre-wrap"
    />
  );
}

export function Strong({ children, ...props }) {
  return (
    <>
      <strong
        {...props}
        children={children}
        style={{ color: "hsl(10, 75%, 48%)" }}
        className="font-semibold"
      />
    </>
  );
}

function Code({ children, ...props }) {
  return (
    <code
      {...props}
      children={children}
      className="px-2 py-1 font-mono whitespace-pre-wrap bg-gray-300 rounded-lg"
    />
  );
}
